import React from 'react';

import { THEME_VARIANTS } from '../../constants/style.constants';
import { computeThemeVariantFromInitials } from '../../helpers/style.helpers';

import { DashboardAvatarProps } from './DashboardAvatar.decl';

import { Avatar } from '@aircall/tractor';

export const DashboardAvatar = React.memo(
  ({ initials, id, src, ...avatarProps }: DashboardAvatarProps) => {
    const variant = computeThemeVariantFromInitials(initials, THEME_VARIANTS);
    const dataTest = id ? `dashboard-avatar-${id}` : 'dashboard-avatar';

    return (
      <Avatar data-test={dataTest} src={src || undefined} variant={variant} {...avatarProps}>
        {initials}
      </Avatar>
    );
  }
);
